import { Form } from 'factorial-form'

class PolicyCreateForm extends Form {
  constructor(values: {}) {
    super(values, {
      name: 'string',
    })
  }

  get isValid() {
    return !!this.get('name').value
  }
}

export default PolicyCreateForm
